import { useMutation } from 'react-query';
import { resetPassword } from '../../../state/context/AuthContext';

export default function useResetPassword() {
  return useMutation((email: string) => resetPassword(email));
}
